module.exports = "\r\n<div>\r\n    <div *ngIf=\"!hidepdf\" class=\"embed-responsive pdf-display\">\r\n        <embed [src]=\"srcUrl\" type=\"application/pdf\"/>\r\n    </div>\r\n    <a *ngIf=\"hidepdf && label\" [href]=\"srcUrl\" target=\"_blank\" class=\"animated fadeIn\"><button class=\"btn btn-primary\">{{label}}</button></a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/pdf-resource/pdf-resource.component.html
// module id = 6wyb
// module chunks = 1